import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LayoutService } from '../service/layout.service';
import { AuthService } from 'src/services/auth.service';
import { ProfileEnumLabel } from '@/providers/enums/profile-Enum';
import { environment } from 'src/environments/environment';
import { AvatarModule } from 'primeng/avatar';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, AvatarModule],
    template: ` <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
                <i class="pi pi-bars"></i>
            </button>
            <a class="layout-topbar-logo">
                <span>Nordsol Energia Solar</span>
            </a>
        </div>

        <div class="layout-topbar-actions">
            <div class="layout-config-menu">
                <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                    <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
                </button>
            </div>

            <div class="layout-topbar-menu hidden lg:block">
                <div class="layout-topbar-menu-content cursor-pointer" routerLink="/app/usuario/perfil">
                    <div class="flex flex-row items-center gap-1">
                        <p-avatar [image]="userImage" shape="circle" size="large" loading="lazy" />
                        <div class="flex flex-col items-center text-center leading-tight">
                            <strong class="capitalize text-sm">{{ userName | lowercase }}</strong>
                            <span class="text-xs opacity-70">{{ profileUser }}</span>
                            @if(env != 'production') {<span class="text-xs opacity-50">{{ env }}</span>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
})
export class AppTopbar {

    items!: MenuItem[];
    userName: string = "";
    profileUser: string = "";
    userImage: string = "";
    env: string = "";

    constructor(
        public layoutService: LayoutService,
        private readonly authService: AuthService,
    ) {
        this.userName = this.authService.getUsername();
        this.userImage = this.authService.userImage();
        this.profileUser = ProfileEnumLabel.get(this.authService.getUserPerfil()) ?? '';
        this.env = environment.envName;
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }
}
